import React from 'react';

export default function Neesa() {
    return (
        <article>
            <p>Neesa Kenemy has been teaching Pilates and Therapeutic Pilates for nineteen years. Neesa is certified through Laura Helsel at Pilates Process Inc. where she is also an instructor trainer.</p>

            <p>Her classes address hip mobility, foot stability, neck/shoulder placement and how they work together to increase strength, balance and pain free movement. Developing one's fascial system is a major key to efficient body mechanics and Neesa includes fascial fitness in each Pilates class she teaches.</p>

            <p>Her one-hour Pilates sessions are tailored to each individual client and can range from therapeutic work, right up through advanced exercises. Intensity is layered on bit by bit as strength and mobility increases. Over the years, Neesa has worked with those recovering from injuries, new parents, athletes, dancers, clients with brain and spinal chord injuries, as well as individuals who are simply renewing their commitment to health.</p>

            <p>It is truly Neesa's passion to enable clients to live more confident, energetic lives by increasing stability, mobility, and focus.</p>
        </article>
    )
};
